import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as AuthenticationActions from '../Actions/AuthenticationActions.js';
import * as userActions from '../Actions/userActions.js';
import Login from "../Components/Authentication/Login.js";
import Logout from "../Components/Authentication/Logout.js";
import { authService } from "../Services/AuthenticationService.js";
import { userService } from "../Services/UserService.js";
import { withRouter } from "react-router-dom";
import { compose } from 'redux';
import { normalize } from 'normalizr';
import { userSchema } from '../Schemas/OrderSchema.js';

class AuthenticationContainer extends Component {
	constructor(props){
		super(props);
		this.login=this.login.bind(this);
		this.logout=this.logout.bind(this);
		this.switchUser=this.switchUser.bind(this);
		this.switchLogout=this.switchLogout.bind(this);
		this.fetchUserRecords=this.fetchUserRecords.bind(this);
	}
	
	login(username, password){
		//console.log("login");
		localStorage.clear();
		authService.login(username, password)
				.then(response => { this.props.actions.loginAction(response.data);
									return authService.getProfile();})
				.then(response => { this.props.actions.setProfile(response.data);
									if(response.data.role=='ADMIN'){
										return userService.listUsers().then(response => { return this.fetchUserRecords(response.data) });
									}else{
										return 1;
									}
								})
//				.then(response => {return this.fetchUserRecords(response.data);})
				.then(response => {return this.props.history.push('/orderList');})
				.catch(err => {/*console.log(err);*/});
	}
	
	fetchUserRecords(responseData){
//		console.log("fetchUserRecords");
		var normalizedData = normalize(responseData, [userSchema]);
		this.props.actions.fetchUserRecords(normalizedData.entities.users);
		return 1;
	}
	
	logout(){
		//console.log("logout");
		authService.logout()
			.then(response => {this.props.actions.logoutAction();})
		localStorage.clear();
	}
	switchUser(username){
//		console.log(JSON.stringify(this.props.history));
		//console.log("switchUser");
		authService.switchUser(username)
			.then(response => {this.props.actions.switchUser(this.props.user.username, response.data);
								return authService.getProfile();})
			.then(response => {return this.props.actions.setProfile(response.data);})
//			.then(response => {return this.props.history.push('/quotationList');})
//			.then(response => {return this.props.history.replace('/orderList');})
			.then(response => {return this.props.history.push('/orderList');})
			.then(response => {return window.location.reload();})
			.catch(err => {/*console.log(err);*/});
	}
	
	switchLogout(){
//		console.log(JSON.stringify(this.props.history));
		//console.log("switchLogout");
		authService.switchUserLogout()
			.then(response => {this.props.actions.switchUserLogout(response.data);
								return authService.getProfile();})
			.then(response => {return this.props.actions.setProfile(response.data);})
//			.then(response => {return userService.listUsers();})
//			.then(response => { return this.fetchUserRecords(response.data) })
//			.then(response => {return this.props.history.replace('/orderList');})
			.then(response => {return this.props.history.push('/orderList');})
//			.then(response => {return this.props.history.push('/quotationList');})
//			.then(response => {return this.props.history.push('/orderList');})
			.then(response => {return window.location.reload();})
			.catch(err => {/*console.log(err);*/});
	}
	
	
	
	render() {
		if(this.props.user.logedIn===true){
			return (<Logout 
							user={this.props.user}
							logout={this.logout}
							switchUser={this.switchUser}
							switchLogout={this.switchLogout}
							userRecords={this.props.userRecords}
							/>);
	    }else{
	    	return (<Login login={this.login}/>);
	    }
	}
}
function mapStateToProps(state, ownProps) {  
	return {user: state.user, userRecords: state.users}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(Object.assign({}, AuthenticationActions, userActions), dispatch)}
}

export default compose (withRouter, connect(mapStateToProps, mapDispatchToProps))(AuthenticationContainer);  